import React, { useState, useEffect } from "react";
// import "../css/Blog.css";
import NAV from "./nav";
import Carousel from "./carousel";
import {fetchBlog} from "../api";
import PriceScroller from "../components/pricescroll";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredCategory, setFilteredCategory] = useState(null);

  const postsPerPage = 5;

  // useEffect(() => {
  //   fetch("http://localhost:8000/api/posts/")
  //     .then((response) => response.json())
  //     .then((data) => setPosts(data))
  //     .catch((error) => console.error("Error fetching blog posts:", error));
  // }, []);

  useEffect(() => {
    fetchBlog()
      .then((data) => setPosts(data))
      .catch((error) => console.error("Error fetching blog posts:", error));
  }, []);

  console.log("POSTS ->",posts)
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const filteredPosts = filteredCategory ? posts.filter(post => post.category === filteredCategory) : posts;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const filterByCategory = (category) => {
    setFilteredCategory(category);
    setCurrentPage(1);
  };

  return (
      <div>
          {/*<!-- Navbar & Hero Start -->*/}
        <div class="container-fluid position-relative p-0">
            <NAV activetag="blog"/>
            <Carousel activetag="blog"/>
            {/*<!-- Header Start -->*/}
            <div class="container-fluid bg-breadcrumb">
                {/*<div class="container text-center py-5" style={{maxwidth: '500px'}}>*/}
                <div className="container text-center py-2" style={{maxwidth: '500px', maxHeight: '100px'}}>
                    <h4 class="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Orion Analytics Blog </h4>
                    <h4 class="text-white display-8 mb-4 wow fadeInDown" data-wow-delay="0.1s">Insights, Trends, and Analysis on Finance, Markets, and Investments</h4>
                    {/*<ol class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">*/}
                    {/*    <li class="breadcrumb-item"><a href="index1.html">Home</a></li>*/}
                    {/*    <li class="breadcrumb-item"><a href="#">Pages</a></li>*/}
                    {/*    <li class="breadcrumb-item active text-primary">Service</li>*/}
                    {/*</ol>*/}
                </div>
            </div>
        </div>
            {/*<!-- Header End -->*/}
        {/*<!-- Navbar & Hero End -->*/}

    <div className="blog-container">
      {/* Top Navigation with Categories */}
      <div className="blog-topbar">
        <ul>
          <li onClick={() => setFilteredCategory(null)} className={!filteredCategory ? "active-category" : ""}>
            Show All
          </li>
          {["Market Update", "Market Trends", "Investment Strategies", "AI & Finance", "Macroeconomics", "Policy & Regulation","Education"].map((category) => (
            <li
              key={category}
              onClick={() => setFilteredCategory(category)}
              className={filteredCategory === category ? "active-category" : ""}
            >
              {category}
            </li>
          ))}
        </ul>
      </div>

      {/* Main Blog Layout */}
      <div className="blog-main">
        {/* Blog List Panel */}
        <div className="blog-list">
          {posts
            .filter((post) => !filteredCategory || post.category === filteredCategory)
            .map((post) => (
              <div key={post.id} className="blog-post" onClick={() => setSelectedPost(post)}>
                <h6>{post.title}</h6>
                <p className="date">{post.date}</p>
              </div>
            ))}
        </div>

        {/* Blog Content Panel */}
        <div className="blog-content">
          {selectedPost ? (
            <div className="blog-details">
              {/*<button className="close-btn" onClick={() => setSelectedPost(null)}>*/}
              {/*  ×*/}
              {/*</button>*/}
              {/*<h2>{selectedPost.title}</h2>*/}
              <p className="date">{selectedPost.date}</p>
              <div dangerouslySetInnerHTML={{ __html: selectedPost.content }} />
              {selectedPost.media &&
                selectedPost.media.map((media, index) => (
                  media.file_type === "image" ? (
                    <img key={index} src={media.file_url} alt="Blog Media" className="blog-image" />
                  ) : (
                    <video key={index} controls className="blog-video">
                      <source src={media.file_url} type="video/mp4" />
                    </video>
                  )
                ))}
            </div>
          ) : (
            <p>Select a blog post to read.</p>
          )}
        </div>
      </div>

      {/* Inline CSS */}
      <style jsx>{`
        body {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 0;
          background-color: #f5f5f5;
        }

        .blog-container {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        .blog-topbar {
          display: flex;
          justify-content: center;
          background-color: #003366;
          padding: 10px;
        }

        .blog-topbar ul {
          list-style: none;
          display: flex;
          gap: 15px;
        }

        .blog-topbar li {
          color: white;
          cursor: pointer;
          padding: 5px 10px;
        }

        //.blog-topbar li:hover {
        //  background-color: #0055a5;
        //  border-radius: 5px;
        //}

        .blog-topbar li:hover, .active-category {
          background-color: #0055a5;
          border-radius: 5px;
        }
        .blog-main {
          display: flex;
          width: 100%;
          height: 100vh;
        }

        .blog-list {
          width: 15%;
          background: #b8d3e5;
          padding: 20px;
          overflow-y: auto;
          border-right: 1px solid #ddd;
          font-size: 16px !important;
        }

        .blog-post {
          padding: 10px;
          margin-bottom: 10px;
          border-bottom: 1px solid #ddd;
          cursor: pointer;
          font-size: 10px;
        }

        .blog-post:hover {
          background-color: #f0f0f0;
          //background-color: #b8d3e5;
        }

        .blog-content {
          width: 85%;
          padding: 20px;
          background: white;
          overflow-y: auto;
        }

        .blog-details img {
          width: 100%;
          height: auto;
          margin-top: 10px;
        }

        .blog-details video {
          width: 100%;
          margin-top: 10px;
        }

        .close-btn {
          background: red;
          color: white;
          border: none;
          padding: 5px 10px;
          cursor: pointer;
          float: right;
        }

        .close-btn:hover {
          background: darkred;
        }
      `}</style>
    </div>
  </div>
  );
};

export default Blog;
